import React from "react"
import ReactModal from "react-modal"

import settings from "../content/settings.json"

import "./AboutModal.sass"

const contentStyle = {
	width: "100%",
	maxWidth: "75vw",
	maxHeight: "100vh",
	height: "auto",
	position: "absolute",
	top: "50vh",
	left: "50vw",
	right: "none",
	bottom: "none",
	padding: "2rem",
	transform: "translate(-50%, -50%)",
	boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.12)",
	borderRadius: "3px",
	border: "none",
	// overflow: "visible",
	overflow: "scroll",
	color: "white",
	backgroundColor: "black",
	fontSize: "1.25rem",
	fontFamily: "monospace",
}

const overlayStyle = {
	backgroundColor: "rgba(0, 0, 0, 0.7)",
	zIndex: 100,
}

export default function AboutModal({ isOpen, setOpen }) {
	return (
		<ReactModal
			isOpen={isOpen}
			style={{ content: contentStyle, overlay: overlayStyle }}
			onRequestClose={() => setOpen && setOpen(false)}
			ariaHideApp={false}
		>
			<pre
				className="Textbox"
				dangerouslySetInnerHTML={{ __html: settings.about_text }}
			/>
		</ReactModal>
	)
}
